import { createFormObject, updateFormObject } from '../handlers/formDataHandler.ts'
import { loginHandler } from '../handlers/loginHandler.ts'
import { controlState } from '../store/controlState.ts'
import { dataState, setProfile } from '../store/dataState.ts'
import { uploadAndSavePhoto } from '../helpers/uploadHelper.ts'
import { shapeAddress } from '../helpers/dataHelpers.ts'
import { useViewTransitionNavigate } from './useViewTransitionNavigate.ts'

export const useForm = () => {
    const { navigate } = useViewTransitionNavigate();

    const onSubmit = async (form: string, data: any): Promise<void> => {
        // console.log(form, data)

        switch (form) {
            case 'login': {
                const route = await loginHandler(data)
                route !== '/' && navigate(route)
                controlState.showLoader = false
            }
                break

            // @ts-ignore
            case 'pet': {
                // console.log('pet', data)
                let petsUpdate
                let breedsUpdate
                let speciesUpdate
                // upload photo
                await uploadAndSavePhoto(data)
                let result
                if (data._id && data._id !== 'new') {
                    result = await updateFormObject('pet', data)
                } else {
                    result = await createFormObject('pet', data)
                }
                if (result) {
                    petsUpdate = result.pets
                    breedsUpdate = result.breeds
                    speciesUpdate = result.species
                }
                if (breedsUpdate) {
                    dataState.breeds = (breedsUpdate)
                }
                if (speciesUpdate) {
                    dataState.species = (speciesUpdate)
                }
                if (petsUpdate) {
                    dataState.pets = (petsUpdate)
                }
                navigate(`/${controlState.currentPage}`)
            }
                break

            // @ts-ignore
            case 'profile': {
                // console.log('profile', data)
                const profile = await updateFormObject('profile', shapeAddress(data))
                if (profile) {
                    setProfile(profile)
                    navigate('/' + controlState.currentPage)
                }
            }
                break

            // @ts-ignore
            case 'homeAddress': {
                // console.log('homeAddress', data)
                const profile = await updateFormObject('homeAddress', data)
                if (profile) {
                    setProfile(profile)
                }
            }
                break

            // @ts-ignore
            case 'contact': {
                // console.log('contact', data)
                let contacts
                if (data._id && data._id !== 'new') {
                    contacts = await updateFormObject('contact', data)
                } else {
                    contacts = await createFormObject('contact', data)
                }
                if (contacts) {
                    dataState.contacts = (contacts)
                }
            }
                break

            default:
                console.log(form, data)
                break
        }
    }

    return [onSubmit] as const
}
